import React from 'react';
import { hot } from 'react-hot-loader/root';
import { Container, Grid, GridItem, Heading } from '@charlietango/ui';
import { rem } from 'polished';

import { useAuth } from '../../api/AuthProvider';
import ArticleSection from '../../components/ArticleSection/ArticleSection';
import ArticleSectionViewModel from '../../components/ArticleSection/types/ArticleSectionViewModel';
import Image from '../../components/Image/Image';
import RichText from '../../components/RichText/RichText';
import { Colors } from '../../styles/colors';
import { TextVariant } from '../../styles/typography';
import ImageViewModel from '../../view-models/ImageViewModel';
import TextBlockViewModel from '../../view-models/TextBlockViewModel';

export type ArticleProps = {
  image?: ImageViewModel;
  article?: TextBlockViewModel;
  articleSections?: ArticleSectionViewModel[];
};

export function ArticlePage({ image, article, articleSections }: ArticleProps) {
  const { loginUrl, logoutUrl } = useAuth();

  return (
    <>
      <article>
        {image && (
          <Image
            {...image}
            sizes={['100vw']}
            css={{
              objectFit: 'cover',
              objectPosition: 'center',
              width: '100%',
              height: '40vh',
              minHeight: 320,
              maxHeight: 540,
            }}
          />
        )}
        <Container>
          {article && (
            <Grid>
              <GridItem size={[1, null, 8 / 12]}>
                <div
                  sx={{
                    position: 'relative',
                    backgroundColor: Colors.White,
                    pt: [6, 7, rem(56)],
                    pr: [0, null, 10],
                    pb: [rem(40), rem(72)],
                    pl: [null, null, rem(96)],
                    mt: [0, null, rem(-56)],
                    ml: [null, null, rem(-96)],
                  }}
                >
                  <Heading
                    as="h1"
                    variant={TextVariant.H2}
                    sx={{ mb: [4, null, 7] }}
                  >
                    {article.title}
                  </Heading>
                  <RichText params={{ loginUrl, logoutUrl }}>
                    {article.text}
                  </RichText>
                </div>
              </GridItem>
            </Grid>
          )}
        </Container>
      </article>
      <Container sx={{ pb: [rem(80), rem(120)] }}>
        {articleSections &&
          articleSections.map((section, i) => (
            <React.Fragment key={i}>
              {i !== 0 && <div sx={{ pb: rem(32) }} />}
              <ArticleSection
                {...section}
                itemSpan={[1, 1 / 2, 1 / 3, 1 / 4]}
              />
            </React.Fragment>
          ))}
      </Container>
    </>
  );
}

ArticlePage.displayName = 'ArticlePage';

export default !process.env.HOT ? ArticlePage : hot(ArticlePage);
